import { Action, createFeature, createReducer, on } from '@ngrx/store';
import * as actions from '../actions/support.actions';
import { initialSupportState, SupportState } from '../state/support.state';

export const supportFeatureStoreKey: string = 'supportState';

export const reducers = (state: SupportState, action: Action): SupportState => {
  return initReducer(state, action);
};

export const initReducer = createReducer(
  initialSupportState,
  on(actions.selectFaqCategory, (state, { category }) => ({
    ...state,
    activeFaqCategory: category,
    openAccordionId: null,
  })),
  on(actions.toggleAccordionItem, (state, { id }) => ({
    ...state,
    openAccordionId: state.openAccordionId === id ? null : id,
  })),
  on(actions.resetAccordionState, (state) => ({
    ...state,
    openAccordionId: null,
  })),
);

export const supportFeature = createFeature({
  name: supportFeatureStoreKey,
  reducer: reducers,
});
